import { FetchMonthlyBillsAPIResponse } from '../../../services/monthlyBills'
import { BaseReducerState, MonthlyBillsResponse } from '../../../services'
import { ActionTypes } from '../actions'

export type FetchMonthlyBillState = BaseReducerState & {
  data: MonthlyBillsResponse[]
}

export const initialState: FetchMonthlyBillState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const fetchMonthlyBill = (
  state: FetchMonthlyBillState = initialState,
  action: { type: string; res: any }
): FetchMonthlyBillState => {
  switch (action.type) {
    case `${ActionTypes.FETCH_MONTHLY_BILL}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.FETCH_MONTHLY_BILL}_SUCCESS`: {
      const { success, data, message } = <FetchMonthlyBillsAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.FETCH_MONTHLY_BILL}_FAILURE`:
      const res = <FetchMonthlyBillsAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.FETCH_MONTHLY_BILL}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
